import React, { useContext } from 'react';
import { AccessibilityRole, NativeSyntheticEvent, NativeTouchEvent, Platform, StyleSheet, ViewStyle } from 'react-native';
import { Text, ThemeContext } from '..';

export interface HyperTextProps {
  children: string;
  onPress: (e: NativeSyntheticEvent<NativeTouchEvent>) => void;
  style?: ViewStyle;
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    text: {
      fontFamily: theme.font.family,
      fontWeight: '500',
      textDecorationLine: 'underline',
    },
  });

export const HyperText = ({ children, onPress, style }: HyperTextProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  const textStyles = [styles.text, style];

  const props = { onPress, style: textStyles };
  const textProps = Platform.OS === 'web' ? { ...props, accessibilityRole: 'link' as AccessibilityRole } : props;

  return <Text {...textProps}>{children}</Text>;
};
